module.exports = __webpack_public_path__ + "img/bg_expo.710fcd53.jpg";